<template>
  <v-navigation-drawer
    fixed
    width="650px"
    v-model="importData.isNavOpen"
    temporary
    right
  >
    <v-col cols="12">
      <v-card class="mx-auto">
        <v-card-title>
          Import Specimen Data
        </v-card-title>
        <v-card-text>
          <v-file-input
            label="Upload Biobank Data"
            v-model="file"
            type="file"
            outlined
            accept=".xlsx"
            @change="onFileChange"
          ></v-file-input>
          <v-autocomplete
            v-model="selectSpecimenSource"
            :items="specimenSourceItems"
            item-value="code"
            item-text="label"
            outlined
            dense
            label="Specimen Source (if applicable)"
            placeholder="Select Specimen Source"
          ></v-autocomplete>
          <!--      v-model="values"
            :items="items" -->
          <v-autocomplete
            v-model="selectProjectCode"
            :items="projectCodeItems"
            item-value="code"
            item-text="label"
            outlined
            dense
            label="Project Code"
            placeholder="Select Project Code"
          ></v-autocomplete>
          <v-autocomplete
            v-model="selectProjectCodeForm"
            :items="projectCodeFormItems"
            item-value="code"
            item-text="label"
            outlined
            dense
            label="Select Form (if applicable)"
            placeholder="Select Form"
            :disabled="!selectProjectCode"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            color="primary"
            style="margin-top: 20px"
            :disabled="!file
              || !selectProjectCode
              || !selectSpecimenSource"
            @click="proceedImport"
          >
            Import
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-navigation-drawer>
</template>

<script>
import services from '../../services';

const { medicalRegistry } = services;
const { protocolNumberService, specimenSourceService, formService } = medicalRegistry;

export default {
  name: 'SidebarExport',
  props: {
    title: String,
    importData: Object,
  },
  data: () => ({
    file: null,
    selectProjectCode: '',
    selectProjectCodeForm: '',
    selectSpecimenSource: '',
    projectCodeItems: [],
    projectCodeFormItems: [],
    specimenSourceItems: [],
  }),
  methods: {
    onFileChange(event) {
      this.file = event;
    },
    proceedImport() {
      const formData = new FormData();
      formData.append('attachment', this.file);
      const projectCodeId = this.selectProjectCode;
      const specimenSourceId = this.selectSpecimenSource;
      const projectFormId = this.selectProjectCodeForm;
      this.importData.onImportData({
        formData,
        projectCodeId,
        specimenSourceId,
        projectFormId,
      });
    },
    getProjectCodeLabelId(projectCodeData) {
      const { _id, protocolNumber } = projectCodeData;
      return {
        label: protocolNumber,
        code: _id,
      };
    },
    setFieldLabelId(data) {
      const { _id, name } = data;
      return {
        label: name,
        code: _id,
      };
    },
  },
  async created() {
    const projectCodeData = await protocolNumberService.getList();
    const specimenSourceData = await specimenSourceService.getList();

    this.projectCodeItems = projectCodeData.map((pcd) => this.getProjectCodeLabelId(pcd));
    this.specimenSourceItems = [
      { code: null, label: 'Not Applicable' },
      ...specimenSourceData.map((ss) => this.setFieldLabelId(ss)),
    ];
  },
  watch: {
    async selectProjectCode() {
      const getFormdata = await formService.getList();
      const getSelectedProjectData = await protocolNumberService.getOne({
        id: this.selectProjectCode,
      });

      this.projectCodeFormItems = getFormdata.map((pcd) => this.setFieldLabelId(pcd));

      this.projectCodeFormItems = this.projectCodeFormItems.filter(
        (projectForm) => getSelectedProjectData.medicalForms.some(
          (medicalForms) => medicalForms.includes(projectForm.code),
        ),
      );
    },
  },
};
</script>
